import { Popup, PopupContent } from "semantic-ui-react";

const Tooltip = ({ content, trigger, children, style }) => {
  return (
    <Popup
      content={content}
      trigger={trigger}
      style={{ ...style, height: "100%" }}
    >
      <PopupContent>{children}</PopupContent>
    </Popup>
  );
};

export default Tooltip;
